import script from "./InfoCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoCard.vue?vue&type=script&setup=true&lang=ts"

import "./InfoCard.vue?vue&type=style&index=0&id=007414c7&lang=css"

const __exports__ = script;

export default __exports__